// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ti2l","rootNoMargin":"styles_rootNoMargin__1LFZ2"};